import { CSS, StyleProps } from "@shared/primitive-components"

export const loaderAlignment = (): CSS => ({
  paddingRight: `1.5rem`,
})

export const loading = (): CSS => ({
  height: `176px`,
})

export const vehicleDetailsHeading = (props: StyleProps): CSS => ({
  textTransform: `uppercase`,
  fontSize: props.theme.fontSize.body,
  marginBottom: props.theme.spacing(2),
})

export const marginRight = (): CSS => ({
  marginRight: `40px`,
})

export const marginBottom = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(6),
})

export const detailsContainer = (props: StyleProps): CSS => ({
  [props.theme.breakPoints.md.down]: {
    overflowX: `scroll`,
  },
})
